module.exports = __webpack_public_path__ + "img/logo-blue.dbca6a9b.svg";